import moment from "moment";
import { useEffect, useState } from "react";
import { DateFormFlush, DateFormRangeFlush } from "./Forms.profile";
import { GiPencil } from "react-icons/gi";
import toast from "react-hot-toast";
import { AdminService } from "../../../../../services/admin.service";

const AdditionalInfo = ({profile, setProfile}:any) => {

    const [loading, setLoading] = useState(false)
    const [additionalData, setAdditionalData] = useState<any>({
        experience:profile.instructor_profile.experience || [],
        education:profile.instructor_profile.education || [],
        awards:profile.instructor_profile.awards || [],
        affiliations: profile.instructor_profile.affiliations || [],
    })


    const saveProfile = async (e:any) => {
        e.preventDefault()
        try{
            setLoading(true);
            const profile1 = {
                experience: profile.instructor_profile.experience,
                education: profile.instructor_profile.education,
                awards: profile.instructor_profile.awards,
                affiliations: profile.instructor_profile.affiliations
            }
            await AdminService.updateInstructorProfileByUserId(profile.instructor_profile._id, profile1).then((res)=>{
                if(res.status==200){
                    toast.success("Profile updated");
                }
            })
            .catch((err)=>{
                console.log(err);
                toast.error("Someting went wrong");
            })

            setLoading(false);

        } catch(err){
            console.log(err)
            setLoading(false)
            throw err;
        }
    }
    

    return (
        <div className = "mt-5 pt-3">
            <Experiece
                profile={profile}
                setProfile={setProfile}
            />
            <Education
                profile={profile}
                setProfile={setProfile}
            />
            <AwardsCertificate
                profile={profile}
                setProfile={setProfile}
            />
            <Affilications
                profile={profile}
                setProfile={setProfile}
            />
            <button disabled = {loading} className = 'btn btn-block my-5 btn-primary px-6' onClick={(e)=>{saveProfile(e)}}>
                {loading && <span className = "spinner-border spinner-border-sm mr-2"></span>}
                Save
            </button>
        </div>
    )
}

export default AdditionalInfo;





const Experiece = ({profile, setProfile}:any) => {

    const [addNew, setAddNew] = useState(false);
    
    const [tempData, setTempData] = useState({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    
    const placeholders = {
        title: 'Job Title', description: 'Job Description', dateRange: 'Time Period', subTitle: 'Company/Institute'
    }

    const saveData = () => {
        const newExperience = [...profile.instructor_profile.experience, tempData]
        const sortedByDate = newExperience.sort((a,b) => {
            return (new Date(b.dateRange.from).getTime() - new Date(a.dateRange.from).getTime())*-1;
        })
        setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, experience: sortedByDate}}));
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    }

    const editData = (index:number) => {
        const currentProfile = {...profile}
        const newData = currentProfile.experience.splice(index, 1);
        setProfile(currentProfile);
        setTempData(newData[0])
        setAddNew(true)
    }

    const deleteData = () => {
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''});

    }


    return (
        <div className = 'form-group mb-5 pb-2'>
            <div className = 'row justify-content-between align-items-center mb-3'>
                <div className = "col">
                    <label className = 'bold mb-1'>Experience</label>
                    <div className = 'text-muted small'>{"Please share the details of your experience"}</div>
                </div>
                <div className = "col-auto col-lg-3">
                    <div className = 'btn btn-sm btn-block btn-primary' onClick = {() => setAddNew(true)}>Add</div>
                </div>
            </div>
            <div className = 'card shadow-sm border'>
                <div className = 'card-body pt-0 pb-0'>
                    {(profile.instructor_profile && profile.instructor_profile.experience) && profile.instructor_profile.experience.map((item:any, index:number) => (
                        <DataRowFilled 
                            title = {item.title} 
                            description = {item.description} 
                            subTitle = {item.subTitle}
                            dateText = {moment(item.dateRange.from).format('Do MMM YY') + ' - ' + moment(item.dateRange.to).format('Do MMM YY')}
                            editData = {editData}
                            index= {index}
                        />))}
                </div>
            </div>
            {addNew ? <DataRow deleteData = {deleteData} placeholders = {placeholders} tempData = {tempData} setTempData = {setTempData} saveData = {saveData}/> : ''}
        </div>
    )
}

const Education = ({profile, setProfile}:any) => {

    const [addNew, setAddNew] = useState(false);
    const [tempData, setTempData] = useState({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    const placeholders = {
        title: 'Degree/Field of Study', description: 'Description', dateRange: 'Date range', subTitle: 'School/Institute'
    }

    const saveData = () => {
        const newEducation = [...profile.instructor_profile.education, tempData]
        const sortedByDate = newEducation.sort((a,b) => {
            return (new Date(b.dateRange.from).getTime() - new Date(a.dateRange.from).getTime())*-1;
        })
        setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, education: sortedByDate}}));
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    }

    const editData = (index:any) => {
        const currentProfile = {...profile}
        const newData = currentProfile.education.splice(index, 1);
        setProfile(currentProfile);
        setTempData(newData[0])
        setAddNew(true)
    }

    const deleteData = () => {
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    }


    return (
        <div className = 'form-group mb-5 pb-2'>
            <div className = 'row justify-content-between align-items-center mb-3'>
                <div className = "col">
                    <label className = 'bold mb-1'>Education</label>
                    <div className = 'text-muted small'>{"Please share details of your educational background"}</div>
                </div>
                <div className = "col-auto col-lg-3">
                    <div className = 'btn btn-sm btn-block btn-primary' onClick = {() => setAddNew(true)}>Add</div>
                </div>
            </div>
                <div className = 'card shadow-sm border'>
                <div className = 'card-body pt-0 pb-0'>
                    {(profile.instructor_profile && profile.instructor_profile.education ) && profile.instructor_profile.education.map((item:any, index:any) => (
                        <DataRowFilled 
                            title = {item.title} 
                            description = {item.description} 
                            subTitle = {item.subTitle}
                            dateText = {moment(item.dateRange.from).format('Do MMM YY') + ' - ' + moment(item.dateRange.to).format('Do MMM YY')}
                            editData = {editData}
                            index= {index}
                        />))}
                </div>
            </div>
            {addNew ? <DataRow deleteData = {deleteData} placeholders = {placeholders} tempData = {tempData} setTempData = {setTempData} saveData = {saveData}/> : ''}
        </div>
    )
}

const AwardsCertificate = ({profile, setProfile}:any) => {

    const [addNew, setAddNew] = useState(false);
    const [tempData, setTempData] = useState({title: '', description: '', date: '', subTitle: ''})
    const placeholders:any = {
        title: 'Award Name', description: 'Description', date: 'Date received', subTitle: 'Entity name'
    }

    const saveData = () => {
        const newAwards = [...profile.instructor_profile.awards, tempData]
        const sortedByDate = newAwards.sort((a,b) => {
            return (new Date(b.date).getTime() - new Date(a.date).getTime())*-1;
        })
        setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, awards: sortedByDate}}));
        setAddNew(false);
        setTempData({title: '', description: '', date: '', subTitle: ''})
    }

    const editData = (index:any) => {
        const currentProfile = {...profile}
        const newData = currentProfile.awards.splice(index, 1);
        setProfile(currentProfile);
        setTempData(newData[0])
        setAddNew(true)
    }

    const deleteData = () => {
        setAddNew(false);
        setTempData({title: '', description: '', date: '', subTitle: ''})
    }

    return (
        <div className = 'form-group mb-5 pb-2'>
            <div className = 'row justify-content-between align-items-center mb-3'>
                <div className = "col">
                    <label className = 'bold mb-1'>Awards and Certification</label>
                    <div className = 'text-muted small'>{"Please share the details of all awards that you have won for your musical abilities"}</div>
                </div>
                <div className = "col-auto col-lg-3">
                    <div className = 'btn btn-sm btn-block btn-primary' onClick = {() => setAddNew(true)}>Add</div>
                </div>
            </div>
            <div className = 'card shadow-sm border'>
                <div className = 'card-body pt-0 pb-0'>
                    {(profile.instructor_profile && profile.instructor_profile.awards) && profile.instructor_profile.awards.map((item:any, index:any) => (
                        <DataRowFilled 
                            title = {item.title} 
                            description = {item.description} 
                            subTitle = {item.subTitle}
                            dateText = {moment(item.date).format('Do MMM YY')}
                            editData = {editData}
                            index= {index}
                        />))}
                </div>
            </div>
            {addNew ? <DataRow deleteData = {deleteData} placeholders = {placeholders} tempData = {tempData} setTempData = {setTempData} saveData = {saveData}/> : ''}
        </div>
    )
}


const Affilications = ({profile, setProfile}:any) => {

    const [addNew, setAddNew] = useState(false);
    const [tempData, setTempData] = useState({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    const placeholders = {
        title: 'Affiliation Title', description: 'Description', dateRange: 'Period of Affiliation', subTitle: 'Institute Name'
    }

    const saveData = () => {
        const newAffiliations = [...profile.instructor_profile.affiliations, tempData]
        const sortedByDate = newAffiliations.sort((a,b) => {
            return (new Date(b.dateRange.from).getTime() - new Date(a.dateRange.from).getTime())*-1;
        })
        setProfile((prev:any) => ({...prev, instructor_profile:{...prev.instructor_profile, affiliations: sortedByDate}}));
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    }

    const editData = (index:any) => {
        const currentProfile = {...profile}
        const newData = currentProfile.affiliations.splice(index, 1);
        setProfile(currentProfile);
        setTempData(newData[0])
        setAddNew(true)
    }

    const deleteData = () => {
        setAddNew(false);
        setTempData({title: '', description: '', dateRange: {from: '', to: ''}, subTitle: ''})
    }

    return (
        <div className = 'form-group mb-5 pb-2'>
            <div className = 'row justify-content-between align-items-center mb-3'>
                <div className = "col">
                    <label className = 'bold mb-1'>Affiliations</label>
                    <div className = 'text-muted small'>{"Please share the details of your active musical affiliations, if any"}</div>
                </div>
                <div className = "col-auto col-lg-3">
                    <div className = 'btn btn-sm btn-block btn-primary' onClick = {() => setAddNew(true)}>Add</div>
                </div>
            </div>
            <div className = 'card shadow-sm border'>
                <div className = 'card-body pt-0 pb-0'>
                    {(profile.instructor_profile && profile.instructor_profile.affiliations) && profile.instructor_profile.affiliations.map((item:any, index:any) => (
                        <DataRowFilled 
                            title = {item.title} 
                            description = {item.description} 
                            subTitle = {item.subTitle}
                            dateText = {moment(item.dateRange.from).format('Do MMM YY') + ' - ' + moment(item.dateRange.to).format('Do MMM YY')}
                            editData = {editData}
                            index= {index}
                        />))}
                </div>
            </div>
            {addNew ? <DataRow deleteData = {deleteData} placeholders = {placeholders} tempData = {tempData} setTempData = {setTempData} saveData = {saveData}/> : ''}
        </div>
    )
}




const DataRow = ({tempData, placeholders, setTempData, saveData, deleteData}:any) => {
    
    const[error, setError] = useState<any>('')
    
    const validate = () => {
        let error = false
        if(placeholders.subTitle && tempData.subTitle === '') error = true;
        if(placeholders.date && tempData.date === '') error = true;
        if(placeholders.title && tempData.title === '') error = true;
        if(placeholders.description && tempData.description === '') error = true;
        if(placeholders.dateRange && (tempData.dateRange.from === '' || tempData.dateRange.to === '')) error = true;
        setError(true);
        if(!error) saveData();
    }

    useEffect(() => {
        setError(false);
    }, [tempData])

    return(
    <div className = 'card shadow-sm border'>
        <div className = 'card-body py-3'>
            <div className = "">
                <div className = "row align-items-center">
                    <div className = "col">
                        <input 
                            placeholder = {placeholders.title} 
                            className = "form-control form-control-flush h4" 
                            value = {tempData.title} 
                            onChange = {e => setTempData((prev:any) => ({...prev, title: e.target.value}))}
                        />
                    </div>
                    <div className = "col-12 col-lg-3">
                        {placeholders.date ? (
                        <DateFormFlush
                            value={tempData.date}
                            setValue={(value:any) => setTempData((prev:any) => ({...prev, date: value}))}
                            placeholder={placeholders.date}
                        />) : (
                        <DateFormRangeFlush
                                value={tempData.dateRange}
                                setValue={(value:any) => setTempData((prev:any) => ({...prev, dateRange: value}))}
                                placeholder={placeholders.dateRange}
                        />)}
                    </div>
                </div>
                <input 
                    placeholder = {placeholders.subTitle} 
                    className = "form-control form-control-flush mt-0" 
                    value = {tempData.subTitle} 
                    onChange = {e => setTempData((prev:any) => ({...prev, subTitle: e.target.value}))}
                />
                <div className = "row">
                    
                </div>
                <textarea 
                    placeholder = {placeholders.description} 
                    className = " small form-control form-control-flush" 
                    style = {{fontSize: '0.8125rem'}}
                    value = {tempData.description} 
                    onChange = {e => setTempData((prev:any) => ({...prev, description: e.target.value}))}
                />
            </div>
            {error ? <div className = 'invalid-feedback d-block'>You missed out some info</div> : ''}
            <div className = 'd-flex justify-content-start mt-3'>
                <div className = 'btn btn-sm btn-primary mr-3' onClick = {() => validate()}>Save</div>
                <div className = 'btn btn-sm btn-outline-secondary mr-3' onClick = {() => deleteData()}>Delete</div>
            </div>
        </div>
    </div>
    )
}


const DataRowFilled = ({ title, subTitle, dateText, description, editData, index }: any) => {
    return (

        <div className="border-bottom mt-4 py-3">
            <div className="row align-items-center">
                <div className="col-12 col-lg">
                    <div className="h4 mb-2">
                        {title}
                        <span className="d-inline-block d-lg-none pb-1 ml-3">
                            <GiPencil className="pointer" onClick={() => editData(index)} />
                        </span>
                    </div>
                    <div>{subTitle}</div>
                </div>
                <div className="col-auto text-center mt-3 mt-lg-0">
                    {dateText}
                </div>
                <div className="col-auto d-none d-lg-block">
                    <GiPencil className="pointer" onClick={() => editData(index)} />
                </div>
            </div>
            <div className="small mt-3 mt-lg-2 pb-3">{description}</div>
        </div>
    )
}